(function(){
  var supportedLanguages = ["af","sq","am","ar","hy","az","eu","be","bn","bs","bg","ca","ceb","zh-CN","zh-TW","co","hr","cs","da","nl","en","eo","et","tl","fi","fr","fy","gl","ka","de","el","gu","ht","ha","haw","he","hi","hmn","hu","is","ig","id","ga","it","ja","jw","kn","kk","km","rw","ko","ku","ky","lo","la","lv","lt","lb","mk","mg","ms","ml","mt","mi","mr","mn","my","ne","no","ny","or","ps","fa","pl","pt","pa","ro","ru","sm","gd","sr","st","sn","sd","si","sk","sl","so","es","su","sw","sv","tg","ta","tt","te","th","tr","tk","uk","ur","ug","uz","vi","cy","xh","yi","yo","zu","as","ay","bho","br","ch","dv","doi","ee","fo","gn","ilo","kri","mai","lus","mni-Mtei","nso","om","qu","sa","sat"];

  var languageDisplayNames = {"af":"Afrikaans","sq":"Albanian","am":"Amharic","ar":"Arabic","hy":"Armenian","az":"Azerbaijani","eu":"Basque","be":"Belarusian","bn":"Bengali","bs":"Bosnian","bg":"Bulgarian","ca":"Catalan","ceb":"Cebuano","zh-CN":"Chinese (Simplified)","zh-TW":"Chinese (Traditional)","co":"Corsican","hr":"Croatian","cs":"Czech","da":"Danish","nl":"Dutch","en":"English","eo":"Esperanto","et":"Estonian","tl":"Filipino","fi":"Finnish","fr":"French","fy":"Frisian","gl":"Galician","ka":"Georgian","de":"German","el":"Greek","gu":"Gujarati","ht":"Haitian Creole","ha":"Hausa","haw":"Hawaiian","he":"Hebrew","hi":"Hindi","hmn":"Hmong","hu":"Hungarian","is":"Icelandic","ig":"Igbo","id":"Indonesian","ga":"Irish","it":"Italian","ja":"Japanese","jw":"Javanese","kn":"Kannada","kk":"Kazakh","km":"Khmer","rw":"Kinyarwanda","ko":"Korean","ku":"Kurdish","ky":"Kyrgyz","lo":"Lao","la":"Latin","lv":"Latvian","lt":"Lithuanian","lb":"Luxembourgish","mk":"Macedonian","mg":"Malagasy","ms":"Malay","ml":"Malayalam","mt":"Maltese","mi":"Maori","mr":"Marathi","mn":"Mongolian","my":"Myanmar (Burmese)","ne":"Nepali","no":"Norwegian","ny":"Nyanja (Chichewa)","or":"Odia (Oriya)","ps":"Pashto","fa":"Persian","pl":"Polish","pt":"Portuguese","pa":"Punjabi","ro":"Romanian","ru":"Russian","sm":"Samoan","gd":"Scots Gaelic","sr":"Serbian","st":"Sesotho","sn":"Shona","sd":"Sindhi","si":"Sinhala","sk":"Slovak","sl":"Slovenian","so":"Somali","es":"Spanish","su":"Sundanese","sw":"Swahili","sv":"Swedish","tg":"Tajik","ta":"Tamil","tt":"Tatar","te":"Telugu","th":"Thai","tr":"Turkish","tk":"Turkmen","uk":"Ukrainian","ur":"Urdu","ug":"Uyghur","uz":"Uzbek","vi":"Vietnamese","cy":"Welsh","xh":"Xhosa","yi":"Yiddish","yo":"Yoruba","zu":"Zulu","as":"Assamese","ay":"Aymara","bho":"Bhojpuri","br":"Breton","ch":"Chamorro","dv":"Divehi (Maldivian)","doi":"Dogri","ee":"Ewe","fo":"Faroese","gn":"Guarani","ilo":"Ilocano","kri":"Krio","mai":"Maithili","lus":"Mizo","mni-Mtei":"Meitei (Manipuri)","nso":"Northern Sotho (Sepedi)","om":"Oromo","qu":"Quechua","sa":"Sanskrit","sat":"Santali"};
  function fixUndefinedLanguageLabels(root){
    root = root || document;
    var selects = [];
    if (root.matches && root.matches("select")) selects.push(root);
    if (root.querySelectorAll) Array.prototype.push.apply(selects, root.querySelectorAll("select"));
    selects.forEach(function(select){
      Array.prototype.forEach.call(select.options, function(option){
        var raw = String(option.value || "").trim();
        var candidates = [raw, raw.split("|").pop(), raw.split("/").pop()];
        var label = "";
        for (var i = 0; i < candidates.length; i++) {
          var candidate = candidates[i].trim();
          if (languageDisplayNames[candidate]) { label = languageDisplayNames[candidate]; break; }
          var lower = candidate.toLowerCase();
          Object.keys(languageDisplayNames).some(function(key){
            if (key.toLowerCase() === lower) { label = languageDisplayNames[key]; return true; }
            return false;
          });
          if (label) break;
        }
        var current = (option.textContent || "").trim();
        if (label && (!current || /undefined|null/i.test(current) || current !== label)) {
          option.textContent = label;
          option.label = label;
        }
      });
    });
  }
  function watchLanguageLabels(){
    fixUndefinedLanguageLabels(document);
    if (document.documentElement && !document.documentElement.__vnLanguageLabelObserver) {
      var observer = new MutationObserver(function(mutations){
        mutations.forEach(function(mutation){
          if (mutation.target && mutation.target.nodeType === 1) fixUndefinedLanguageLabels(mutation.target);
          if (mutation.addedNodes) Array.prototype.forEach.call(mutation.addedNodes, function(node){
            if (node.nodeType === 1) fixUndefinedLanguageLabels(node);
          });
        });
        fixUndefinedLanguageLabels(document);
      });
      observer.observe(document.documentElement, {childList:true,subtree:true,characterData:true});
      document.documentElement.__vnLanguageLabelObserver = observer;
    }
  }

  function configureLanguageSelector(){
    window.gtranslateSettings = {
      default_language: "en",
      languages: supportedLanguages.slice(),
      wrapper_selector: ".gtranslate_wrapper",
      native_language_names: false,
      detect_browser_language: false,
      select_language_label: "Choose language"
    };
    var style = document.getElementById("vn-language-selector-enhancements");
    if (!style) {
      style = document.createElement("style");
      style.id = "vn-language-selector-enhancements";
      style.textContent =
        ".language-form{display:flex;align-items:center;gap:6px;min-width:0;position:relative;z-index:12}" +
        ".language-form .gtranslate_wrapper{width:100%;max-width:160px;min-width:0}" +
        ".language-form select,.gtranslate_wrapper select{display:block;width:100%;max-width:160px;min-width:0;min-height:44px;box-sizing:border-box;border:1px solid #dedfdc;border-radius:4px;background:#fff;color:#141820;padding:9px 24px 9px 8px;font:inherit;font-size:13px;line-height:1.3}" +
        ".gt_float_switcher,.gt_options,.gt_switcher{z-index:30!important}" +
        "@media(max-width:900px){.header-tools{min-width:0}.language-form{max-width:150px}.language-form .gtranslate_wrapper,.language-form select,.gtranslate_wrapper select{max-width:150px;font-size:12px}}" +
        "@media(max-width:600px){.header-tools{grid-template-columns:minmax(0,1fr) 112px!important;gap:6px!important}.language-form{width:112px;max-width:112px}.language-form .gtranslate_wrapper,.language-form select,.gtranslate_wrapper select{width:112px;max-width:112px;font-size:11px;padding:9px 4px}}" +
        "@media(max-width:380px){.header-tools{grid-template-columns:minmax(0,1fr) 96px!important}.language-form,.language-form .gtranslate_wrapper,.language-form select,.gtranslate_wrapper select{width:96px;max-width:96px}}" +
        "html[dir=rtl] .header-tools,html[dir=rtl] .main-nav ul{direction:rtl}";
      document.head.appendChild(style);
    }
  }
  function syncLanguageDirection(){
    var selector = document.querySelector(".gtranslate_wrapper select");
    if (!selector) return;
    var language = (selector.value || "en").toLowerCase();
    var isArabic = language === "ar" || language.indexOf("ar-") === 0;
    document.documentElement.lang = selector.value || "en";
    document.documentElement.dir = isArabic ? "rtl" : "ltr";
    document.body.classList.toggle("vn-rtl", isArabic);
  }
  function initNav(){
    var toggle=document.querySelector(".nav-toggle");
    var nav=document.getElementById("PrimaryNav");
    if(toggle&&nav){
      toggle.addEventListener("click",function(){
        var open=toggle.getAttribute("aria-expanded")==="true";
        toggle.setAttribute("aria-expanded",String(!open));
        nav.classList.toggle("is-open",!open);
      });
    }
    document.querySelectorAll(".submenu-toggle").forEach(function(button){
      button.addEventListener("click",function(){
        var open=button.getAttribute("aria-expanded")==="true";
        button.setAttribute("aria-expanded",String(!open));
        var parent=button.closest(".has-submenu");
        if(parent) parent.classList.toggle("submenu-open",!open);
      });
    });
    document.querySelectorAll('form[role="search"] input[name="q"]').forEach(function(input){
      input.addEventListener("keydown",function(event){if(event.key==="Escape") input.value="";});
    });
    document.addEventListener("change",function(event){
      if(event.target && event.target.closest(".gtranslate_wrapper")) window.setTimeout(syncLanguageDirection,250);
    });
    window.addEventListener("load",function(){window.setTimeout(syncLanguageDirection,600);});
  }
  function start(){
    configureLanguageSelector();
    watchLanguageLabels();
    initNav();
    syncLanguageDirection();
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",start);
  else start();
  window.addEventListener("load", watchLanguageLabels);
  document.addEventListener("DOMContentLoaded", watchLanguageLabels);
})();